import { NgModule } from '@angular/core';
import { IncidentConfirmationService } from './incident-confirmation.service';

@NgModule({
    providers: [
        IncidentConfirmationService
    ]
})
export class IncidentConfirmationModule {
}
